<template>
  <div>
    <breadcrumbs :home="name" :back="back"/>
    <component :is="report" @name="name = $event"/>
<!--
    <component v-if="!$vuetify.breakpoint.mobile" :is="report" @name="name = $event"/>
    <div v-else class="text-center text-h4 mt-16">Sorry, but reports are not available on mobile devices</div>
    -->
  </div>
</template>

<script>

export default {
  name: 'ReportsView',
  props: {
    back: {type:Array, required:false, default:() => [{text:'Reports',to:{name:'Reports'}}]}
  },
  data() {
    return {
      report: null,
      name: ''
    }
  },
  async created() {
    this.report = () => import(`@/views/${this.$route.query.to}`);
  },
  beforeRouteUpdate(to, from , next) {
    this.report = () => import(`@/views/${this.$route.query.to}`);
    next();
  }
}
</script>